{
  "identities.messages.1010001": "ورود",
  "identities.messages.1010002": "ورود با {provider}",
  "identities.messages.1010003": "لطفاً با تأیید این عملیات، اطمینان حاصل کنید که شما هستید.",
  "identities.messages.1010004": "لطفاً چالش دوم احراز هویت را کامل کنید.",
  "identities.messages.1010005": "تایید",
  "identities.messages.1010006": "کد احراز هویت",
  "identities.messages.1010007": "کد بازیابی پشتیبان",
  "identities.messages.1010008": "ادامه با کلید سخت‌افزاری",
  "identities.messages.1010009": "ادامه",
  "identities.messages.1010010": "ادامه",
  "identities.messages.1010011": "ورود با کلید سخت‌افزاری",
  "identities.messages.1010012": "کلید WebAuthn خود را آماده کنید (مثلاً کلید امنیتی، اسکنر بیومتریک، ...) و روی ادامه کلیک کنید.",
  "identities.messages.1010013": "ادامه",
  "identities.messages.1010014": "یک کد به آدرسی که ارائه کردید ارسال شد. اگر آن را دریافت نکردید، لطفاً اسپلینگ آدرس را بررسی کنید و دوباره امتحان کنید.",
  "identities.messages.1010015": "ارسال کد ورود",
  "identities.messages.1010016": "شما سعی کردید با \"{duplicateIdentifier}\" وارد شوید، اما این ایمیل قبلاً توسط یک حساب دیگر استفاده شده است. برای اضافه کردن حساب خود \"{duplicateIdentifier}\" در \"{provider}\" به عنوان روش دیگری برای ورود، با یکی از گزینه‌های زیر به حساب خود وارد شوید.",
  "identities.messages.1010017": "ورود و لینک",
  "identities.messages.1010018": "تایید با {provider}",
  "identities.messages.1010019": "درخواست کد برای ادامه",
  "identities.messages.1010021": "ورود با پس‌کلید",
  "identities.messages.1010022": "ورود با رمز عبور",
  "identities.messages.1010023": "ارسال کد به {address}",
  "identities.messages.1040001": "ثبت‌نام",
  "identities.messages.1040002": "ثبت‌نام با {provider}",
  "identities.messages.1040003": "ادامه",
  "identities.messages.1040004": "ثبت‌نام با کلید امنیتی",
  "identities.messages.1040005": "یک کد به آدرس (ها) ای که ارائه کردید ارسال شده است. اگر پیامی دریافت نکردید، اسپلینگ آدرس را بررسی کنید و ثبت‌نام را دوباره امتحان کنید.",
  "identities.messages.1040006": "ارسال کد ثبت‌نام",
  "identities.messages.1040007": "ثبت‌نام با پس‌کلید",
  "identities.messages.1040008": "بازگشت",
  "identities.messages.1040009": "لطفاً یک اعتبارنامه را برای احراز هویت خود انتخاب کنید.",
  "identities.messages.1050001": "تغییرات شما ذخیره شد!",
  "identities.messages.1050002": "لینک {provider}",
  "identities.messages.1050003": "لغو لینک {provider}",
  "identities.messages.1050004": "لغو لینک اپلیکیشن احراز هویت TOTP",
  "identities.messages.1050005": "کد QR اپلیکیشن احراز هویت",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "نمایش کدهای بازیابی پشتیبان",
  "identities.messages.1050008": "فعال کردن",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "این کدهای بازیابی پشتیبان هستند. لطفاً آنها را در یک مکان امن نگه دارید!",
  "identities.messages.1050011": "تایید کدهای بازیابی پشتیban",
  "identities.messages.1050012": "افزودن کلید امنیتی",
  "identities.messages.1050013": "نام کلید امنیتی",
  "identities.messages.1050014": "رمز عبور در تاریخ {used_at, date, long} استفاده شده است",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "غیرفعال کردن این روش",
  "identities.messages.1050017": "رمز احراز هویت",
  "identities.messages.1050018": "حذف کلید امنیتی \"{display_name}\"",
  "identities.messages.1050019": "افزودن پس‌کلید",
  "identities.messages.1050020": "حذف پس‌کلید \"{display_name}\"",
  "identities.messages.1060001": "حساب شما با موفقیت بازیابی شد. لطفاً رمز عبور خود را تغییر دهید یا یک روش ورود جایگزین (مثلاً ورود اجتماعی) را در مدت {privileged_session_expires_at_unix_until_minutes} دقیقه آینده تنظیم کنید.",
  "identities.messages.1060002": "یک ایمیل حاوی یک لینک بازیابی به آدرس ایمیلی که ارائه کردید ارسال شده است. اگر ایمیلی دریافت نکردید، اسپلینگ آدرس را بررسی کنید و مطمئن شوید که از آدرسی که ثبت‌نام کردید استفاده می‌کنید.",
  "identities.messages.1060003": "یک ایمیل حاوی یک کد بازیابی به آدرس ایمیلی که ارائه کردید ارسال شده است. اگر ایمیلی دریافت نکردید، اسپلینگ آدرس را بررسی کنید و مطمئن شوید که از آدرسی که ثبت‌نام کردید استفاده می‌کنید.",
  "identities.messages.1060004": "یک کد بازیابی به \"{masked_address}\" ارسال شده است. اگر آن را دریافت نکردید، اسپلینگ آدرس را بررسی کنید و مطمئن شوید که از آدرسی که ثبت‌نام کردید استفاده می‌کنید.",
  "identities.messages.1060005": "برای بازیابی دسترسی به حساب خود، آدرس بازیابی خود را به طور کامل وارد کنید.",
  "identities.messages.1060006": "چگونه می‌خواهید حساب خود را بازیابی کنید؟",
  "identities.messages.1060007": "بازگشت",
  "identities.messages.1070001": "رمز عبور",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "ذخیره",
  "identities.messages.1070004": "شناسه",
  "identities.messages.1070005": "ارسال",
  "identities.messages.1070006": "تایید کد",
  "identities.messages.1070007": "ایمیل",
  "identities.messages.1070008": "ارسال مجدد کد",
  "identities.messages.1070009": "ادامه",
  "identities.messages.1070010": "کد بازیابی",
  "identities.messages.1070011": "کد تایید",
  "identities.messages.1070012": "کد ثبت‌نام",
  "identities.messages.1070013": "کد ورود",
  "identities.messages.1070014": "ورود و لینک اعتبارنامه",
  "identities.messages.1070015": "لطفاً چالش captcha را کامل کنید تا ادامه دهید.",
  "identities.messages.1070016": "آدرس بازیابی",
  "identities.messages.1070017": "شماره تلفن",
  "identities.messages.1080001": "یک ایمیل حاوی یک لینک تایید به آدرس ایمیلی که ارائه کردید ارسال شده است. اگر ایمیلی دریافت نکردید، اسپلینگ آدرس را بررسی کنید و مطمئن شوید که از آدرسی که ثبت‌نام کردید استفاده می‌کنید.",
  "identities.messages.1080002": "ایمیل شما با موفقیت تایید شد.",
  "identities.messages.1080003": "یک ایمیل حاوی یک کد تایید به آدرس ایمیلی که ارائه کردید ارسال شده است. اگر ایمیلی دریافت نکردید، اسپلینگ آدرس را بررسی کنید و مطمئن شو1د که از آدرسی که ثبت‌نام کردید استفاده می‌کنید.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "لطفاً {property} را وارد کنید و دوباره امتحان کنید.",
  "identities.messages.4000003": "طول باید >= {min_length} باشد، اما {actual_length} دریافت شد",
  "identities.messages.4000004": "با الگوی \"{pattern}\" مطابقت ندارد",
  "identities.messages.4000005": "رمز عبور نمی‌تواند استفاده شود چون {reason}.",
  "identities.messages.4000006": "اعتبارنامه‌های ارائه شده نامعتبر هستند، اشتباهات املایی در رمز عبور یا نام کاربری، آدرس ایمیل، یا شماره تلفن خود را بررسی کنید.",
  "identities.messages.4000007": "یک حساب با شناسه یکسان (ایمیل، تلفن، نام کاربری، ...) قبلاً وجود دارد.",
  "identities.messages.4000008": "کد احراز هویت ارائه شده نامعتبر است، لطفاً دوباره امتحان کنید.",
  "identities.messages.4000009": "هیچ شناسه ورودی پیدا نشد. آیا فراموش کردید آنها را تنظیم کنید؟ این ممکن است ناشی از یک پیکربندی نادرست سرور باشد.",
  "identities.messages.4000010": "حساب هنوز فعال نشده است. آیا فراموش کردید ایمیل خود را تایید کنید؟",
  "identities.messages.4000011": "هیچ دستگاه TOTP تنظیم نشده است.",
  "identities.messages.4000012": "این کد بازیابی پشتیبان قبلاً استفاده شده است.",
  "identities.messages.4000013": "هیچ دستگاه WebAuthn تنظیم نشده است.",
  "identities.messages.4000014": "هیچ کد بازیابی پشتیبانی تنظیم نشده است.",
  "identities.messages.4000015": "این حساب وجود ندارد یا هیچ کلید امنیتیی تنظیم نشده است.",
  "identities.messages.4000016": "کد بازیابی پشتیبان نامعتبر است.",
  "identities.messages.4000017": "طول باید <= {max_length} باشد، اما {actual_length} دریافت شد",
  "identities.messages.4000018": "باید >= {minimum} باشد اما {actual} دریافت شد",
  "identities.messages.4000019": "باید > {minimum} باشد اما {actual} دریافت شد",
  "identities.messages.4000020": "باید <= {maximum} باشد اما {actual} دریافت شد",
  "identities.messages.4000021": "باید < {maximum} باشد اما {actual} دریافت شد",
  "identities.messages.4000022": "{actual} چند برابر {base} نیست",
  "identities.messages.4000023": "حداکثر {max_items} مورد مجاز است، اما {actual_items} مورد دریافت شد",
  "identities.messages.4000024": "حداقل {min_items} مورد مجاز است، اما {actual_items} مورد دریافت شد",
  "identities.messages.4000025": "موارد در شاخص {index_a} و {index_b} یکسان هستند",
  "identities.messages.4000026": "مورد انتظار {allowed_types_list} بود، اما {actual_type} دریافت شد",
  "identities.messages.4000027": "یک حساب با شناسه یکسان (ایمیل، تلفن، نام کاربری، ...) قبلاً وجود دارد. لطفاً به حساب خود وارد شوید تا پروفیل اجتماعی خود را لینک کنید.",
  "identities.messages.4000028": "شما سعی کردید با {credential_identifier_hint} وارد شوید که قبلاً توسط یک حساب دیگر استفاده شده است. می‌توانید با استفاده از {available_credential_types_list} وارد شوید. می‌توانید با یکی از ارائه‌دهندگان زیر وارد شوید: {available_oidc_providers_list}.",
  "identities.messages.4000029": "باید برابر با ثابت {expected} باشد",
  "identities.messages.4000030": "تایید شکست",
  "identities.messages.4000031": "رمز عبور نمی‌تواند استفاده شود چون بسیار شبیه به شناسه است.",
  "identities.messages.4000032": "رمز عبور باید حداقل {min_length} کاراکتر باشد، اما {actual_length} کاراکتر دریافت شد.",
  "identities.messages.4000033": "رمز عبور باید حداکثر {max_length} کاراکتر باشد، اما {actual_length} کاراکتر دریافت شد.",
  "identities.messages.4000034": "رمز عبور در نشت داده‌ها یافت شده است و نباید دیگر استفاده شود.",
  "identities.messages.4000035": "این حساب وجود ندارد یا روش ورود با کد را تنظیم نکرده است.",
  "identities.messages.4000036": "ویژگی‌های ارائه شده با ویژگی‌های قبلی این جریان مطابقت ندارند.",
  "identities.messages.4000037": "این حساب وجود ندارد یا هیچ روش ورودی تنظیم نشده است.",
  "identities.messages.4000038": "تایید captcha شکست، لطفاً دوباره امتحان کنید.",
  "identities.messages.4010001": "این تعامل به پایان رسید. لطفاً دوباره تلاش کنید.",
  "identities.messages.4010002": "نتوانستیم استراتژی مناسبی برای ورود شما پیدا کنیم. فرم را به درستی پر کردید؟",
  "identities.messages.4010003": "نتوانستیم استراتژی مناسبی برای ثبت‌نام شما پیدا کنیم. فرم را به درستی پر کردید؟",
  "identities.messages.4010004": "نتوانستیم استراتژی مناسبی برای به‌روزرسانی تنظیمات شما پیدا کنیم. فرم را به درستی پر کردید؟",
  "identities.messages.4010005": "نتوانستیم استراتژی مناسبی برای بازیابی حساب شما پیدا کنیم. فرم را به درستی پر کردید؟",
  "identities.messages.4010006": "نتوانستیم استراتژی مناسبی برای تایید حساب شما پیدا کنیم. فرم را به درستی پر کردید؟",
  "identities.messages.4010007": "درخواست قبلاً با موفقیت انجام شده است و نمی‌توان دوباره امتحان کرد.",
  "identities.messages.4010008": "کد ورود نامعتبر است یا قبلاً استفاده شده است. لطفاً دوباره امتحان کنید.",
  "identities.messages.4010009": "اعتبارنامه‌های لینک شده با هم مطابقت ندارند.",
  "identities.messages.4010010": "آدرس وارد شده با هیچ آدرسی در حساب فعلی مطابقت ندارد.",
  "identities.messages.4040001": "این تعامل به پایان رسید. لطفاً دوباره تلاش کنید.",
  "identities.messages.4040002": "درخواست قبلاً با موفقیت انجام شده است و نمی‌توان دوباره امتحان کرد.",
  "identities.messages.4040003": "کد ثبت‌نام نامعتبر است یا قبلاً استفاده شده است. لطفاً دوباره امتحان کنید.",
  "identities.messages.4050001": "این تعامل به پایان رسید. لطفاً دوباره تلاش کنید.",
  "identities.messages.4060001": "درخواست قبلاً با موفقیت انجام شده است و نمی‌توان دوباره امتحان کرد.",
  "identities.messages.4060002": "جریان بازیابی به وضعیت خطا رسیده است و باید دوباره امتحان شود.",
  "identities.messages.4060004": "توکن بازیابی نامعتبر است یا قبلاً استفاده شده است. لطفاً جریان را دوباره امتحان کنید.",
  "identities.messages.4060005": "این تعامل به پایان رسید. لطفاً دوباره تلاش کنید.",
  "identities.messages.4060006": "کد بازیابی نامعتبر است یا قبلاً استفاده شده است. لطفاً دوباره امتحان کنید.",
  "identities.messages.4070001": "توکن تایید نامعتبر است یا قبلاً استفاده شده است. لطفاً جریان را دوباره امتحان کنید.",
  "identities.messages.4070002": "درخواست قبلاً با موفقیت انجام شده است و نمی‌توان دوباره امتحان کرد.",
  "identities.messages.4070003": "جریان تایید به وضعیت خطا رسیده است و باید دوباره امتحان شود.",
  "identities.messages.4070005": "این تعامل به پایان رسید. لطفاً دوباره تلاش کنید.",
  "identities.messages.4070006": "کد تایید نامعتبر است یا قبلاً استفاده شده است. لطفاً دوباره امتحان کنید.",
  "identities.messages.5000001": "{reason}",
  "login.logout-button": "خروج",
  "login.registration-button": "ثبت‌نام",
  "login.registration-label": "حساب ندارید؟",
  "login.title": "ورود",
  "login.subtitle": "با {parts} وارد شوید",
  "login.title-aal2": "احراز هویت دوم",
  "login.subtitle-aal2": "روشی را برای کامل کردن احراز هویت دوم خود انتخاب کنید",
  "login.code.subtitle": "یک کد تایید به ایمیل ارسال می‌شود",
  "login.webauthn.subtitle": "لطفاً دستگاه WebAuthN خود را آماده کنید",
  "login.totp.subtitle": "لطفاً کدی که توسط اپلیکیشن احراز هویت شما تولید شده است را وارد کنید",
  "login.lookup_secret.subtitle": "لطفاً یکی از کدهای بازیابی پشتیبان 8 رقمی خود را وارد کنید",
  "login.title-refresh": "احراز هویت مجدد",
  "login.subtitle-refresh": "هویت خود را با {parts} تأیید کنید",
  "login.2fa.go-back": "چیزی کار نمی‌کند؟",
  "login.2fa.go-back.link": "بازگشت",
  "login.2fa.method.go-back": "روش دیگری را انتخاب کنید",
  "recovery.title": "بازیابی حساب",
  "recovery.subtitle": "شناسه مرتبط با حساب خود را وارد کنید تا یک کد دسترسی یک‌بار مصرف دریافت کنید",
  "registration.login-button": "ورود",
  "registration.login-label": "حساب دارید؟",
  "registration.title": "ثبت‌نام حساب",
  "registration.subtitle": "با {parts} ثبت‌نام کنید",
  "settings.navigation-back-button": "بازگشت",
  "settings.subtitle": "تنظیمات حساب خود را به‌روزرسانی کنید.",
  "settings.title": "تنظیمات حساب",
  "settings.password.title": "تغییر رمز عبور",
  "settings.password.description": "رمز عبور خود را تغییر دهید",
  "settings.profile.title": "تنظیمات پروفیل",
  "settings.profile.description": "اطلاعات پروفیل خود را به‌روزرسانی کنید",
  "settings.webauthn.title": "مدیریت توکن‌های سخت‌افزاری",
  "settings.webauthn.description": "تنظیمات توکن سخت‌افزاری خود را مدیریت کنید",
  "settings.messages.toast-title.success": "تنظیمات به‌روز شد",
  "settings.messages.toast-title.error": "نمی‌توان تنظیمات را به‌روز کرد",
  "verification.title": "تایید حساب",
  "verification.subtitle": "ایمیل مرتبط با حساب خود را وارد کنید تا آن را تایید کنید",
  "two-step.password.title": "رمز عبور",
  "two-step.password.description": "رمز عبور مرتبط با حساب خود را وارد کنید",
  "two-step.code.title": "کد ایمیل",
  "two-step.code.description": "یک کد تایید به ایمیل شما ارسال می‌شود",
  "two-step.webauthn.title": "کلید امنیتی",
  "two-step.webauthn.description": "از کلید امنیتی خود برای احراز هویت استفاده کنید",
  "two-step.passkey.title": "پس‌کلید (توصیه می‌شود)",
  "two-step.passkey.description": "از دستگاه خود برای تشخیص انگشت یا چهره استفاده کنید",
  "two-step.passkey.description.error": "نمی‌توان کتابخانه‌های لازم برای استفاده از پس‌کلید خود را بارگذاری کرد. لطفاً بعداً دوباره امتحان کنید.",
  "two-step.totp.title": "استفاده از اپلیکیشن احراز هویت (TOTP)",
  "two-step.totp.description": "از یک کد 6 رقمی یک‌بار مصرف از اپلیکی یون خود استفاده کنید",
  "two-step.lookup_secret.title": "کد بازیابی پشتیبان",
  "two-step.lookup_secret.description": "یکی از کدهای بازیابی پشتیبان 8 رقمی خود را برای احراز هویت استفاده کنید",
  "input.placeholder": "مقدار {placeholder} خود را وارد کنید",
  "card.header.parts.oidc": "یک ارائه‌دهنده اجتماعی",
  "card.header.parts.password.registration": "{identifierLabel} شما و یک رمز عبور",
  "card.header.parts.password.login": "{identifierLabel} شما و رمز عبور",
  "card.header.parts.code": "یک کد یک‌بار مصرف",
  "card.header.parts.passkey": "یک پس‌کلید",
  "card.header.parts.webauthn": "یک کلید امنیتی",
  "card.header.parts.totp": "اپلیکیشن احراز هویت شما",
  "card.header.parts.lookup_secret": "یک کد بازیابی پشتیبان",
  "card.header.parts.identifier-first": "{identifierLabel} شما",
  "misc.or": "یا",
  "forms.label.forgot-password": "رمز عبور خود را فراموش کردید؟",
  "forms.label.recover-account": "بازیابی حساب",
  "settings.totp.title": "اپلیکیشن احراز هویت",
  "settings.totp.description": "برای بهبود امنیت حساب خود، یک اپلیکیشن احراز هویت TOTP به حساب خود اضافه کنید. اپلیکیشن‌های احراز هویت محبوب شامل LastPass و Google Authenticator هستند.",
  "settings.totp.info.not-linked": "برای فعال کردن، کد QR را با اپلیکیشن احراز هویت خود اسکن کنید و کد را وارد کنید.",
  "settings.totp.info.linked": "در حال حاضر یک اپلیکیشن احراز هویت به حساب شما متصل است.",
  "settings.lookup_secret.title": "کدهای بازیابی پشتیبان (عامل دوم)",
  "settings.lookup_secret.description": "کدهای بازیابی یک پشتیبان امن برای 2FA هستند که به شما اجازه می‌دهند در صورت از دست دادن دستگاه 2FA خود، دوباره به حساب خود دسترسی پیدا کنید.",
  "settings.oidc.title": "حساب‌های متصل",
  "settings.oidc.description": "یک ارائه‌دهنده ورود اجتماعی را با حساب خود لینک کنید.",
  "settings.oidc.info": "حساب‌های متصل از این ارائه‌دهندگان می‌توانند برای ورود به حساب خود استفاده شوند",
  "settings.webauthn.info": "توکن‌های سخت‌افزاری برای احراز هویت عامل دوم یا به عنوان عامل اول با پس‌کلیدها استفاده می‌شوند",
  "settings.passkey.title": "مدیریت پس‌کلیدها",
  "settings.passkey.description": "تنظیمات پس‌کلید خود را مدیریت کنید",
  "settings.passkey.info": "تنظیمات پس‌کلید خود را مدیریت کنید",
  "card.footer.select-another-method": "روش دیگری را انتخاب کنید",
  "account-linking.title": "لینک حساب",
  "property.password": "رمز عبور",
  "property.email": "ایمیل",
  "property.phone": "تلفن",
  "property.username": "نام کاربری",
  "property.identifier": "شناسه",
  "property.code": "کد",
  "property.recovery_address": "آدرس بازیابی",
  "consent.title": "اجازه دهید {party}",
  "consent.subtitle": "یک برنامه سوم دسترسی به اطلاعات مرتبط با حساب شما {identifier} را می‌خواهد.",
  "consent.scope.openid.title": "هویت",
  "consent.scope.openid.description": "اجازه می‌دهد برنامه هویت شما را تأیید کند. این برای احراز هویت و تجربه ورود مطمئن ضروری است.",
  "consent.scope.offline_access.title": "دسترسی آفلاین",
  "consent.scope.offline_access.description": "این برنامه را قادر می‌سازد تا شما را حتی در زمانی که فعال نیستید، وارد حساب کند.",
  "consent.scope.profile.title": "اطلاعات پروفیل",
  "consent.scope.profile.description": "دسترسی به جزئیات پروفیل پایه شما، شامل نام کاربری، نام اول و نام خانوادگی.",
  "consent.scope.email.title": "آدرس ایمیل",
  "consent.scope.email.description": "دریافت آدرس ایمیل شما و وضعیت تأیید آن.",
  "consent.scope.address.title": "آدرس فیزیکی",
  "consent.scope.address.description": "دسترسی به آدرس پستی شما.",
  "consent.scope.phone.title": "شماره تلفن",
  "consent.scope.phone.description": "دریافت شماره تلفن شما و وضعیت تأیید آن.",
  "error.title.what-happened": "چه اتفاقی افتاد؟",
  "error.title.what-can-i-do": "چه کاری می‌توانم انجام دهم؟",
  "error.instructions": "لطفاً چند دقیقه دیگر امتحان کنید یا اپراتور وب‌سایت را تماس بگیرید.",
  "error.footer.text": "وقتی این خطا را گزارش می‌دهید، لطفاً اطلاعات زیر را شامل کنید:",
  "error.footer.copy": "کپی",
  "error.action.go-back": "بازگشت",
  "identities.messages.4000039": "رمز عبور جدید باید با رمز عبور قدیمی متفاوت باشد.",
  "identities.messages.4000040": "یک آدرس ایمیل معتبر وارد کنید",
  "identities.messages.4000041": "یک شماره تلفن معتبر وارد کنید",
  "captcha.error": "تأیید امنیتی ناموفق بود. لطفاً بعداً دوباره تلاش کنید. اگر مشکل ادامه داشت، با پشتیبانی تماس بگیرید.",
  "identities.messages.5000002": "هیچ روش احراز هویتی در دسترس نیست. لطفاً با مدیر سیستم تماس بگیرید.",
  "identities.messages.4010011": "این حساب کاربری غیرفعال شده است. لطفاً برای دریافت راهنمایی با بخش پشتیبانی تماس بگیرید.",
  "identities.messages.1070018": "آدرس ایمیل یا شماره تلفن",
  "identities.messages.1080004": "یک پیامک حاوی کد تأیید به شماره تلفنی که ارائه کرده‌اید، ارسال شده است. اگر پیامکی دریافت نکرده‌اید، لطفاً شماره تلفن را از نظر املایی بررسی کنید و مطمئن شوید که از همان شماره‌ای استفاده می‌کنید که در هنگام ثبت‌نام ارائه داده‌اید.",
  "identities.messages.1080005": "شما با موفقیت شماره تلفن خود را تأیید کردید.",
  "identities.messages.5000003": "سازمان شما به احراز هویت تک‌ورودی (SSO) نیاز دارد، اما هیچ ارائه‌دهنده SSO پیکربندی نشده است. لطفاً با مدیر سیستم تماس بگیرید.",
  "identities.messages.1010024": "با استفاده از یک کلید سخت‌افزاری وارد حساب خود شوید.",
  "identities.messages.1010025": "کدی به آدرس شما ارسال شد. اگر آن را دریافت نکردید، لطفاً دوباره تلاش کنید.",
  "identities.messages.4000042": "شما هیچ دستگاه احراز هویت (DeviceAuthn) را تنظیم نکرده‌اید.",
  "identities.messages.4000043": "اطلاعات ورود به سیستم ارائه شده از طریق احراز هویت وب معتبر نیست، لطفاً دوباره تلاش کنید.",
  "identities.messages.4000044": "امضای ارائه‌شده برای احراز هویت دستگاه، نامعتبر است.",
  "identities.messages.4050002": "شما فقط می‌توانید هر بار یک آدرس را تغییر دهید. لطفاً هر آدرس را به صورت جداگانه به‌روزرسانی کنید."
}
